<template>
    <d-container fluid class="main-content-container px-4 pb-4">
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">Users</h3>
            </d-col>
        </d-row>
        <div v-if="checkPermission(permissionTypes.userRead)">
            <list-users />
        </div>
        <no-permission-message v-else />
    </d-container>
</template>

<script>
import ListUsers from '../../components/users/ListUsers.vue'
import permissions from '../../mixins/permissions';

export default {
    name: "Users",
    mixins: [permissions],
    components: {
        ListUsers,
    },
}
</script>

<style scoped>

</style>
